import { Store } from './store'

export class KakaoInitStore extends Store<boolean> {
  constructor() {
    super(false)
  }

  private readInitialized() {
    if (this.isServer()) {
      return false
    }

    return Boolean(window.Kakao?.isInitialized?.())
  }

  private handleInitialized = () => {
    this.setState(this.readInitialized())
  }

  protected override onFirstSubscribe() {
    if (this.isServer()) {
      return
    }
    this.setState(this.readInitialized())

    window.addEventListener('kakao:initialized', this.handleInitialized)
  }

  protected override onLastUnsubscribe() {
    if (this.isServer()) {
      return
    }

    window.removeEventListener('kakao:initialized', this.handleInitialized)
  }

  getSnapshot = () => {
    if (this.isServer()) {
      return false
    }
    const next = this.readInitialized()
    this.setState(next)
    return next
  }

  getServerSnapshot = () => false
}
